module.exports = __webpack_public_path__ + "img/area_3.d1e7949a.png";